import { CustomizedTypography, Stack, VStack } from '@components/Customized';
import { ConditionalRender } from '@components/Customized';
import {
  CapaPaymentMethodType,
  CapaPurchaseOrderStatus,
  useFetchMyRefundBankAccountsQuery
} from '@generated/graphql';
import { bankMap } from '@utils/bankMap';
import { maskingBankAccount } from '@utils/maskingString';
import { ProgressInfoBottomItemCommonProps } from './types';

const CANCELED_STATES: (CapaPurchaseOrderStatus | undefined)[] = [
  CapaPurchaseOrderStatus.CancelConfirmed,
  CapaPurchaseOrderStatus.RefundConfirmed,
  CapaPurchaseOrderStatus.RejectOrderByPartner
];

const CANCEL_REQUESTED_STATE: (CapaPurchaseOrderStatus | undefined)[] = [
  CapaPurchaseOrderStatus.CancelRequested,
  CapaPurchaseOrderStatus.RefundRequested
];

const Paid = ({
  payment,
  matches,
  purchaseOrderStatus
}: ProgressInfoBottomItemCommonProps) => {
  const { data: refundAccountData } = useFetchMyRefundBankAccountsQuery({
    fetchPolicy: 'cache-and-network'
  });
  const refundAccountList = refundAccountData?.fetchMyRefundBankAccounts?.data;
  const refundAccount = refundAccountList?.[0];
  const { holderName, account, bankCode } = refundAccount ?? {};
  const totalPaid = (payment?.totalAmount ?? 0).toLocaleString('kr');
  const isCard = payment?.paymentMethod === CapaPaymentMethodType.CreditCard;
  const isCanceled = CANCELED_STATES.includes(purchaseOrderStatus);
  const isCancelRequested = CANCEL_REQUESTED_STATE.includes(
    purchaseOrderStatus
  );
  const cardCompany = isCard ? payment?.cardInfo?.cardName : undefined;
  const cardNumberSecret = isCard ? payment?.cardInfo?.cardNumber : undefined;
  const isProcessingStopped = isCanceled || isCancelRequested;

  const amountTtile = isProcessingStopped ? '총 환불금액' : '총 결제금액';

  return (
    <Stack justifyContent="space-between" alignItems="center">
      <ConditionalRender visible={!isCancelRequested}>
        <ConditionalRender visible={isCard}>
          <VStack>
            <CustomizedTypography
              variant="body2"
              color="textPrimary"
              fontWeight="500"
            >
              신용카드
            </CustomizedTypography>
            <CustomizedTypography variant="body2" color="textPrimary">
              {cardCompany} ({cardNumberSecret})
            </CustomizedTypography>
          </VStack>
        </ConditionalRender>

        <ConditionalRender visible={!isCard && isCanceled}>
          <VStack>
            <CustomizedTypography
              variant="body2"
              color="textPrimary"
              fontWeight="500"
            >
              {holderName}
            </CustomizedTypography>
            <CustomizedTypography variant="body2" color="textPrimary">
              {`${bankMap(bankCode)} ${maskingBankAccount(account ?? '')}`}
            </CustomizedTypography>
          </VStack>
        </ConditionalRender>
      </ConditionalRender>

      <VStack>
        <CustomizedTypography
          variant="subtitle2"
          color="textSecondary"
          align="right"
        >
          {amountTtile}
        </CustomizedTypography>
        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          align={isCancelRequested ? 'left' : 'right'}
        >
          {totalPaid}원
        </CustomizedTypography>
      </VStack>
    </Stack>
  );
};

export default Paid;
